module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0051.jpg?v=a8b2d34f";